import React, { useState, useEffect } from "react";
import { Search } from "react-bootstrap-icons";
import {
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  CardText,
} from "reactstrap";
import { BiEditAlt } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "react-datepicker/dist/react-datepicker.css";
import SearchableDropdown from "../../searchableDropdown";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import axios from "axios";
import moment from "moment";
import { baseUrl } from "../../api/apiConfig";
import TripEditModal from "../../components/editModals/TripEditModal";
import ManualAllocationModal from "../../components/humanInLoop/ManualAllocationModal";
import Pagination from "../../Pagination";
// CSS Media Queries..
import "../../styles/Tours/trips.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menus from "../counts/Menus";
import SimpleBar  from "simplebar-react"
// Not used...
// import "bootstrap/dist/css/bootstrap.min.css";


const Trips = () => {
  const [tripData, setTripData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [inputPageNumber, setInputPageNumber] = useState("");
  const [tripPayload, setTripPayload] = useState({
    offset: 0,
    limit: 10,
    status: localStorage.getItem("tripStatus")
      ? localStorage.getItem("tripStatus")
      : "",
    trip_id: localStorage.getItem("tripId")
      ? localStorage.getItem("tripId")
      : "",
    booking_id: localStorage.getItem("tripBookingId")
      ? localStorage.getItem("tripBookingId")
      : "",
    tour_id: localStorage.getItem("triptourId")
      ? localStorage.getItem("triptourId")
      : "",
    pickup_location: "",
    dropoff_location: "",
    pickup_time: localStorage.getItem("pickupDate")
      ? localStorage.getItem("pickupDate")
      : "",
    dropoff_time: localStorage.getItem("dropoffDate")
      ? localStorage.getItem("dropoffDate")
      : "",
      booking_type:localStorage.getItem("trip_booking_type")?localStorage.getItem("trip_booking_type"):"",
  });
  const [totalCount, setTotalCount] = useState(0);

  const [tourModal, setTourModal] = useState(false);
  const [pickup_time, setPickup_time] = useState();
  const [dropoff_time, setDropoff_time] = useState();
  const [trip_modal_date, setTrip_modal_date] = useState("");

  const [checkedItems, setCheckedItems] = useState([]);
  const [selectedObjects, setSelectedObjects] = useState([]);
  const [doneTrips, setDoneTrips] = useState([]);
  const [addressView, setAddressView] = useState(true);
  const [driverList, setDriverList] = useState([]);
  const [driverSelect, setDriverSelect] = useState("");
  const [driverId, setDriverId] = useState(0);
  const [bookingid, setBookingid] = useState([]);
  const [tripStatus, setTripStatus] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [tripEditModal, setTripEditModal] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [check, setCheck] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [doneTripsDataa, setDoneTripsDataa] = useState([]);
  const [loading, setLoading] = useState();
  const [tripCount, setTripCount] = useState("");
  const [allocationTrip, setAllocationTrip] = useState(null);

  const openAllocationModal = (trip) => setAllocationTrip(trip);
  const closeAllocationModal = () => setAllocationTrip(null);

  const handlePageNumber = (e) => {
    setInputPageNumber(e.target.value);
    if (e.target.value == "") {
      console.log("no page no");
      setPageNumber(0);
    }
  };

  console.log(pageNumber);
  const handleGoToPage = () => {
    console.log(inputPageNumber);
    const pageNumber = parseInt(inputPageNumber);
    // setPageNumber(pageNumber - 1)
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= pageCount) {
      setPageNumber(pageNumber - 1); // Page numbers start from 1, but indexes start from 0
    } else {
      console.error("Invalid page number");
    }
  };
  const activeClass = (pageIndex) => {
    console.log("pageIndex :---", pageIndex);
    return parseInt(inputPageNumber) - 1 === pageIndex
      ? "paginationActive"
      : "";
  };

  const handleTripEditModalChanges = (item) => {
    setTripEditModal(!tripEditModal);
    setEditObj(item);
  };

  const changetourModal = () => {
    setTourModal(!tourModal);
    setDriverSelect("");
    setBtnDisable(false);
    // This one empty the Done Trips- Array after Click X "Mark"
    if (tourModal) {
      setDoneTrips([]);
    }
  };

  const showDataPerPage = 10;
  const offset = pageNumber * showDataPerPage;
  const pageCount = Math.ceil(totalCount / showDataPerPage);
  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };


  // Api calling - Get  All Trips Data ..
  const url = `${baseUrl}/booking/getTrips`;

  async function getTrips() {
    try {
      const request = await fetch(`${baseUrl}/booking/getTrips`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...tripPayload,
          limit: showDataPerPage,
          offset: offset,
        }),
      });
      const response = await request.json();
      const tripData = response.data.trips;
      setTripData(tripData);
      setTotalCount(response.data.count);
    } catch (error) {
      console.error("Trip Post request failed", error.message);
    }
  }

  // CheckBox Click Functionality .......

  const handleCheckBoxChange = (id, item, index) => {
    console.log("Get booking id and saved in array");
    setBookingid([...new Set([...bookingid, item.booking_id])]);

    const selectedObj = tripData.find((obj) => obj.id === id);
    // ,transport_type:"pickup",location_address:item.pickup_location
    // ,transport_type:"drop",location_address:item.dropoff_location

    const x = {
      ...selectedObj,
      transType: "pickup",
      transport_type: "pickup",
      location_address: item.pickup_location,
    };
    // setSequenceNum(sequenceNum+1)
    const y = {
      ...selectedObj,
      transType: "drop",
      transport_type: "drop",
      location_address: item.dropoff_location,
    };
    // console.log(x);
    // console.log(y);
    if (selectedObj) {
      setSelectedObjects((prevObj) => {
        const isSelected = prevObj.some((obj) => obj.id === selectedObj.id);
        if (isSelected) {
          return prevObj.filter((obj) => obj.id !== selectedObj.id);
        } else {
          return [...prevObj, x, y];
        }
      });
    }
  };
  console.log("selectedObjects :", selectedObjects);
  console.log("doneTrips :", doneTrips);
  // const newitems=tripData.filter(item1=>{
  //     return selectedObjects.find((item2)=>item2.id!==item1.id)
  // })
  // console.log(newitems,"newitems");

  // Drag & Drop Functionality ........

  const handleDragEnd = (result) => {
    console.log(result);
    if (!result.destination) {
      return;
    }
    // console.log(result.source.droppableId);
    const sourceList =
      result.source.droppableId === "droppable-1" ? selectedObjects : doneTrips;
    //   console.log(result.destination.droppableId);
    const destinationList =
      result.destination.droppableId === "droppable-1"
        ? selectedObjects
        : doneTrips;
    const [removed] = sourceList.splice(result.source.index, 1);
    destinationList.splice(result.destination.index, 0, removed);
    setSelectedObjects([...selectedObjects]);
    //   console.log(...doneTrips);
    setDoneTrips([...doneTrips]);

    // const items=Array.from(checkedItems)
    // const [reorderedItem] = items.splice(result.source.index, 1);
    // items.splice(result.destination.index, 0, reorderedItem);
    // setCheckedItems(items);
  };
  const handleAddressView = () => {
    setAddressView(!addressView);
  };

  // Driver Selection part ...
  const handleSelectDriver = (selectedOption) => {
    console.log(selectedOption, "Driver Name..");
    setDriverSelect(selectedOption);
    setDriverId(selectedOption.value);
  };
  const driverListurl = `${baseUrl}/driver/getDrivers`;
  const getDriverList = async (url) => {
    try {
      const response = await axios.post(url, { limit: 100, offset: 0 });
      if (response.data.success) {
        const driverList = response.data.data.drivers;
        const singleDriver = driverList
          .filter((elem) => elem.available_status == true)
          .map((elem, index) => ({
            label: elem.name + "-" + elem.mobile_number,
            value: elem.user_id,
          }));
        setDriverList(singleDriver);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Filter Functions ...

  // Tour Status...
  const handleTripStatus = (e) => {
    let value = e.target.value;
    setTripStatus(value);
    setTripPayload({
      ...tripPayload,
      status: value,
    });
    localStorage.setItem("tripStatus", value);
  };

  const handleBookingId = (e) => {
    // console.log(e.target.value);
    let bookingId = e.target.value;
    setTripPayload({
      ...tripPayload,
      booking_id: bookingId,
    });
  };

  const handleTripId = (e) => {
    console.log(e.target.value);
    let tripId = e.target.value;
    setTripPayload({
      ...tripPayload,
      trip_id: e.target.value,
    });
  };

  // Tour PickupTime function...
  const handlePickupTime = (date) => {
    let pickupTime = moment(date).format("YYYY-MM-DD");
    setPickup_time(pickupTime);
    setTripPayload({
      ...tripPayload,
      pickup_time: pickupTime,
    });
    localStorage.setItem("pickupDate", pickupTime);
  };
  // Tour Dropofftime function...
  const handleDropoffTime = (date) => {
    let dropoffTime = moment(date).format("YYYY-MM-DD");
    setDropoff_time(dropoffTime);
    setTripPayload({
      ...tripPayload,
      dropoff_time: dropoffTime,
    });
    localStorage.setItem("dropoffDate", dropoffTime);
  };

  console.log("total count for filter", totalCount);
  // Clear Button function...
  const handleClearFilter = () => {
    window.location.reload();
    localStorage.removeItem("tripId");
    localStorage.removeItem("tripBookingId");
    localStorage.removeItem("triptourId");
    localStorage.removeItem("pickupDate");
    localStorage.removeItem("dropoffDate");
    localStorage.removeItem("tripStatus");
    localStorage.removeItem("trip_booking_type");
  };

  console.log(doneTrips, "277");

  // Here trips to Tour conversion fn...
  const handleTriptoTour = async () => {
    setLoading(true);
    let doneTripsData = doneTrips.map((tripSeqData, index) => {
      tripSeqData["sequence_number"] = index + 1;
      return tripSeqData;
    });
    console.log(doneTripsData);
    // setDoneTripsDataa(doneTripsData)
    console.log(selectedObjects);
    const tourreqObj = {
      booking_id: bookingid,
      driver_id: driverId,
      engaged_consolidation_manager: "1",
      is_closed_tour: check,
      sequence: doneTripsData,
      tour_fare: 100,
    };
    console.log("selectedObjects :", selectedObjects);
    console.log("tour req obj");
    console.log(tourreqObj);
    // setBtnDisable(true) // here Sumit button disabled..

    try {
      console.log(tourreqObj);
      const response = await axios.post(`${baseUrl}/tours/addTour`, tourreqObj);
      console.log(response);
      if (response.data.success === true) {
        setBookingid([]);
        setTourModal(false);
        getTrips();
        setDoneTrips([]);
        setLoading(false);
        alert("Your Tour added successfully.");
        // toast.success("Your Tour added successfully",{
        //     className:"toast-success-message",
        //     position: "top-right",
        //     autoClose: 1000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
        //   })
      } else {
        console.log("Something error ?..");
      }
    } catch (error) {
      console.log("Tour Api error", error);
      console.error(error);
    }
  };
  console.log(doneTrips, "288");

  // Delete Icon Fn....

  const handleDeleteModal = (id) => {
    setDeleteModal(!deleteModal);
    setDeleteId(id);
  };

  const deleteSelectedTrip = async (tripId) => {
    console.log(tripId, "delete id");
    try {
      // console.log(`${baseUrl}/booking/deleteTrip/${tripId}`);
      const request = await axios.post(
        `${baseUrl}/booking/deleteTrip/${tripId}`
      );
      if (request.data.success) {
        getTrips(url);
        alert(request.data.message);
        setDeleteModal(false);
      }
    } catch (error) {
      alert("Failed to Delete !");
      console.error(error.message);
    }
  };

  useEffect(() => {
    getDriverList(driverListurl);
  }, []);
  useEffect(() => {
    getTrips(tripPayload);
  }, [offset, pageNumber]);

  const handleSaveEdit = (editedData) => {
    console.log(editedData, "jjjj");
  };

  console.log("pageNO", pageNumber);
  console.log("pageNO", offset);

  console.log(tripPayload, "----tripPayload");

  return (
    <div style={{ padding: "10px" }} id="tripContainer">
      <section className="searchBar-section">
        <div className="session-Top-Input">
          <Search className="searchIcon" />
          <input
            type="text"
            placeholder="Search owner by name,phone or address"
            style={{ width: "310px" }}
          />
        </div>
        <div className="vehicle-btns">
          <button className="btn-big" onClick={changetourModal}>
            Create Tour
          </button>
        </div>
      </section>

      <section className="booking-main-input trips-filter">
        <div className="inpBox-1">
          <input
            type="text"
            placeholder="Trip id"
            value={tripPayload.trip_id}
            onChange={(e) => {
              setTripPayload({ ...tripPayload, trip_id: e.target.value });
              localStorage.setItem("tripId", e.target.value);
            }}
          />
          <input
            type="text"
            placeholder="Booking id"
            value={tripPayload.booking_id}
            onChange={(e) => {
              setTripPayload({ ...tripPayload, booking_id: e.target.value });
              localStorage.setItem("tripBookingId", e.target.value);
            }}
          />
          <input
            type="text"
            placeholder="Tour id"
            value={tripPayload.tour_id}
            onChange={(e) => {
              setTripPayload({ ...tripPayload, tour_id: e.target.value });
              localStorage.setItem("triptourId", e.target.value);
            }}
          />
          <DatePicker
            value={tripPayload.pickup_time}
            onChange={(date) => {
              handlePickupTime(date);
            }}
            dateFormat="yyyy-MM-dd"
            placeholderText="Pickup Date"
          />
          <DatePicker
            value={tripPayload.dropoff_time}
            onChange={(date) => handleDropoffTime(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Dropoff Date"
          />
        </div>
        <div className="inpBox-2">
             <select name="" id=""
            value={tripPayload.booking_type}
            onChange={(e)=>{
              const bookingType=e.target.value.trim()
              setTripPayload((tripPayload)=>({...tripPayload,booking_type:bookingType}))
              localStorage.setItem("trip_booking_type",bookingType)
            }}
          >
            <option value="">Choose Booking</option>
            <option value="GoodMove">GoodMove</option>
            <option value="ONDC">ONDC</option>
          </select>
          <select value={tripPayload.status} onChange={handleTripStatus}>
            <option value="choose status" selected>
              Choose status
            </option>
            <option value="Pending">Pending</option>
            <option value="Reached drop">Reached drop</option>
            <option value="Completed pickup">Completed pickup</option>
            <option value="Completed drop">Completed drop</option>
            <option value="Reached pickup">Reached pickup</option>
          </select>
        </div>
        <div className="inpBox-3">
          {/* <button className="btn-big" onClick={filterByValue}>Filter</button> */}
          <button className="btn-big" onClick={() => getTrips()}>
            Filter
          </button>
          <button className="btn-big" onClick={handleClearFilter}>
            Clear
          </button>
        </div>
      </section>

      <div>
        <Modal
          isOpen={tourModal}
          size="xl"
          scrollable
          className="tour_modal "
          id="tour-modal-mobile"
        >
          <ModalHeader
            style={{ border: "none" }}
            toggle={changetourModal}
          ></ModalHeader>
          <ModalBody>
            <DragDropContext onDragEnd={handleDragEnd}>
              <div style={{ display: "flex", gap: "10px" }}>
                <div>
                  <p style={{ textAlign: "center" }}>Unassigned Trips</p>
                  <div className="dropDiv">
                    <div className="unassignedTrips">
                      <Droppable droppableId="droppable-1" direction="vertical">
                        {(provided) => (
                          <ul
                            className="draggableList"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {selectedObjects.map((item, index) => (
                              <Draggable
                                key={item.trip_id.toString() + index}
                                draggableId={item.trip_id + index}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    className="draggableItem"
                                    ref={provided.innerRef}
                                    {...provided.dragHandleProps}
                                    {...provided.draggableProps}
                                  >
                                    <Card color="success" inverse>
                                      <CardBody>
                                        <CardText>
                                          <u>
                                            {item.booking_id} - {item.transType}
                                          </u>{" "}
                                          <b>:</b> <br />
                                          {addressView ? (
                                            <p>
                                              {item.transType === "pickup"
                                                ? item.pickup_location.substring(
                                                    0,
                                                    30
                                                  )
                                                : item.dropoff_location.substring(
                                                    0,
                                                    30
                                                  )}
                                            </p>
                                          ) : (
                                            <p>
                                              {item.transType === "pickup"
                                                ? item.pickup_location
                                                : item.dropoff_location}
                                            </p>
                                          )}
                                        </CardText>
                                        <button
                                          onClick={handleAddressView}
                                          className="card-button"
                                        >
                                          <span>
                                            {addressView ? (
                                              <>
                                                <FaArrowUp /> ShowMore
                                              </>
                                            ) : (
                                              <>
                                                <FaArrowDown /> ShowLess
                                              </>
                                            )}
                                          </span>
                                        </button>
                                      </CardBody>
                                    </Card>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </div>
                  </div>
                </div>

                <div>
                  <p style={{ textAlign: "center" }}>Create New Tour</p>
                  <div className="dropDiv">
                    <div className="createTour">
                      <Droppable droppableId="droppable-2" direction="vertical">
                        {(provided) => (
                          <ul
                            className="draggableList"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {doneTrips.map((item, index) => (
                              <Draggable
                                key={item?.id.toString() + index}
                                draggableId={item.id.toString() + index}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    className="draggableItem"
                                    ref={provided.innerRef}
                                    {...provided.dragHandleProps}
                                    {...provided.draggableProps}
                                  >
                                    <Card color="success" inverse>
                                      <CardBody>
                                        <CardText>
                                          <u>
                                            {item.booking_id} - {item.transType}
                                          </u>{" "}
                                          <b>:</b> <br />
                                          {addressView ? (
                                            <p>
                                              {item.transType === "pickup"
                                                ? item.pickup_location.substring(
                                                    0,
                                                    30
                                                  )
                                                : item.dropoff_location.substring(
                                                    0,
                                                    30
                                                  )}
                                            </p>
                                          ) : (
                                            <p>
                                              {item.transType === "pickup"
                                                ? item.pickup_location
                                                : item.dropoff_location}
                                            </p>
                                          )}
                                          {/* {item.transType === "pickup" ? (item.pickup_location.substring(0,30)):(item.dropoff_location.substring(0,30))} */}
                                        </CardText>
                                        <button
                                          onClick={handleAddressView}
                                          className="card-button"
                                        >
                                          <span>
                                            {addressView ? (
                                              <>
                                                <FaArrowUp /> ShowMore
                                              </>
                                            ) : (
                                              <>
                                                <FaArrowDown /> ShowLess
                                              </>
                                            )}
                                          </span>
                                        </button>
                                        {/* <button  className='btn-small'>show</button> */}
                                      </CardBody>
                                    </Card>
                                  </div>
                                  // <li className="draggableItem" ref={provided.innerRef}{...provided.dragHandleProps}{...provided.draggableProps}>
                                  // {item.booking_id} - {item.transType}:{item.transType === "pickup" ? (item.pickup_location.substring(0,30)):(item.dropoff_location).substring(0,30)}
                                  // </li>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </div>
                  </div>
                </div>

                <div>
                  <p>Choose Driver</p>
                  <div>
                    <Select
                      options={driverList}
                      value={driverSelect}
                      onChange={handleSelectDriver}
                      isSearchable
                      placeholder="Search or Select by Driver name.."
                      noOptionsMessage={() => "Check...."}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "25px",
                    }}
                  >
                    <p style={{ position: "relative", top: "15px" }}>
                      <input
                        type="checkbox"
                        onClick={(e) => setCheck(e.target.checked)}
                      />{" "}
                      Is Closed Tour ?
                    </p>

                    {/* <button className={btnDisable ? "card-btn-disabled" :"card-btn-submit"} 
                                disabled={btnDisable} onClick={handleTriptoTour}>
                                    SUBMIT
                                </button> */}
                    <button
                      className="card-btn-submit"
                      onClick={handleTriptoTour}
                    >
                      {loading ? (
                        <div className="loading-addTour-spinner-container">
                          <div className="loading-addTour-spinner"></div>
                        </div>
                      ) : (
                        "SUBMIT"
                      )}
                    </button>
                    {/* <ToastContainer position='top-center'/> */}
                  </div>
                </div>
              </div>
            </DragDropContext>
          </ModalBody>
        </Modal>
      </div>

      {/* Delete Modal */}
      <Modal
        isOpen={deleteModal}
        size="sm"
        style={{ marginTop: "5%" }}
        className="delete-modal-mobile"
      >
        <ModalHeader
          toggle={handleDeleteModal}
          style={{ border: "none" }}
        ></ModalHeader>
        <ModalBody>
          <div id="deleteModalBody">
            <p>Are you sure you want to delete?</p>
            <div className="confirm-cancel-button">
              <button onClick={() => deleteSelectedTrip(deleteId)}>
                Confirm
              </button>
              <button onClick={() => handleDeleteModal()}>Cancel</button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <section>
        <TripEditModal
          tripEditModal={tripEditModal}
          handleTripEditModalChanges={handleTripEditModalChanges}
          editObj={editObj}
          onSave={handleSaveEdit}
        />
      </section>
      <ManualAllocationModal
        isOpen={Boolean(allocationTrip)}
        booking={allocationTrip}
        onClose={closeAllocationModal}
        onSaved={getTrips}
      />
      <div>
          <Table responsive style={{ marginTop: "20px" }} className="trips_Table">
            <thead  >
              <tr style={{ borderBottom: "1px solid black", fontSize: "12px" }}>
                <th></th>
                <th >EDIT</th>
                <th >DELETE</th>
                <th >TRIP ID</th>
                <th >BOOKING ID</th>
                <th>ALLOCATION</th>
                <th >PICKUP LOCATION</th>
                <th >EARLIEST PICKUP TIME</th>
                <th >DROP OFF LOCATION</th>
                <th>EARLIEST DROP OFF TIME</th>
                <th>TOUR ID</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody  >
              {tripData.map((item, index) => {
                return (
                  <tr
                    key={item.id}
                    style={{
                      borderBottom: "1px solid lightgrey",
                      textAlign: "left",
                      fontSize: "13px",
                    }}
                  >
                    <td >
                      {item.tour_id ? (
                        ""
                      ) : (
                        <input
                          type="checkbox"
                          checked={selectedObjects.some(
                            (selectedObj) => selectedObj.id === item.id
                          )}
                          onChange={() =>
                            handleCheckBoxChange(item.id, item, index)
                          }
                          style={{
                            position: "relative",
                            top: "8px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </td>
                    <td style={{ fontSize: "18px" }} >
                      <BiEditAlt />
                    </td>
                    <td style={{ fontSize: "18px", cursor: "pointer" }} >
                      <RiDeleteBin5Line
                        className="deleteIcon"
                        onClick={() => handleDeleteModal(item.trip_id)}
                      />
                    </td>
                    <td >{item.trip_id}</td>
                    <td >{item.booking_id}</td>
                    <td>
                      <button
                        type="button"
                        className="hitl-allocation-button"
                        onClick={() => openAllocationModal(item)}
                      >
                        {item.tour_id ? "Manage" : "Assign"}
                      </button>
                    </td>
                    <td style={{ maxWidth: "300px"}}>
                      {item.pickup_location}
                    </td>
                    <td >
                      {moment(item.pickup_time).format("YYYY-MM-DD HH:mm:ss ")}
                    </td>
                    <td style={{ maxWidth: "300px" }}>
                      {item.dropoff_location}
                    </td>
                    <td>{item.dropoff_time}</td>
                    <td>{item.tour_id}</td>
                    <td>{item.status}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

      <section id="tripsPagination">
        <div className="paginationContainer">
          <Pagination
            pageNumber={pageNumber}
            handlePageChange={handlePageChange}
            pageCount={pageCount}
            activeClass={activeClass}
          />
        </div>
      </section>
    </div>
  );
};

export default Trips;
